// extracted by mini-css-extract-plugin
export default {"layout":"layout--T44gZ","aside-wrapper":"aside-wrapper--YH7Xq","page-content":"page-content--K08sz","article":"article--hO8e7"};